// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"7b3e4d06","206":"9b08d763","293":"23b5f054","589":"c11b6609","692":"7e87095d","758":"ec982786","986":"96946adb"}[chunkId] + ".chunk.js";
};